import React, { useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Helmet from 'react-helmet'

import styles from './styles.module.scss'

const CareerGrid = (props) => {
    
    // const data = useStaticQuery(graphql`
    //     query {
    //         careers: allStoryblokEntry(filter: {
    //             field_component: {
    //                 eq: "career"
    //             }
    //         }) {
    //             nodes {
    //                 id
    //                 slug
    //                 field_component
    //                 content
    //                 name
    //             }
    //         }
    //     }
    // `)

    useEffect(() => {
        const script = document.createElement('script') 
        script.async = true 
        script.defer = true 
        script.src = 'https://assets.rippling-ats.com/javascripts/embed.js' 
        document.querySelector('div#hiringthing-jobs').appendChild(script) 
    }, [])

    return (
        <section className={styles['career-grid']}>
            {/* <ContentGrid blok={props.blok} data={data} type='careers' /> */}

            <div className='container'>
                <h2 className={`heading-1 ${styles['career-grid__heading']}`}><b>{props.blok.heading}</b></h2>
            </div>

            <Helmet>
                <link rel='stylesheet' type='text/css' media='all' href='https://assets.rippling-ats.com/stylesheets/embed.css' />
            </Helmet>

            <div className='container' id='hiringthing-jobs'></div>
        </section>
    )
}

export default CareerGrid